import React, { useEffect, useState, useContext, useRef } from 'react'
import "./css/TableView.css"
import Delivery from "./images/icons/delivery.png"
import Pickup from "./images/icons/pickup.png"
import Parcel from "./images/Menu/Parcel.png"
import AddTable from "./images/icons/add.png"
import merge from "./images/icons/merge.png"
import save from "./images/icons/save.png"
import Search from "./images/icons/search.png"
import Add from "./images/icons/plus.png"
import Remove from "./images/icons/remove.png"
import { useNavigate } from 'react-router-dom'
import NavBarMobile from './Mobile/NavBar'
import MobileViewTables from './js/mobileViewTables.json'
import SideNav from './SideNav'
import SideNavMob from './SideNavMob'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import io from 'socket.io-client';
import axios from 'axios'
import { DBContext } from './DBContext'
import { DineContext } from './DineContext'
import Roundtable from "./images/icons/Round table.png"
import TableReg from "./TableReg";
function TableView() {

	const { logginedDB, sideNavState, sideNavStateFunc, userType, userRights, hasPermission = () => true } = useContext(DBContext);

	const { setPreviewPreviousOrders, setAlreadySelectedVariants, setPreviousOrdersFunc } = useContext(DineContext);

	const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
	const [activeTab, setActiveTab] = useState("Dine in");

	const isMyOpenedTableRestricted = () => {
		const loggedInUser = localStorage.getItem('userName') || localStorage.getItem('USER');
		if (loggedInUser === 'shersoft') {
			return false; // shersoft is never restricted
		}
		return !!(userRights && (Number(userRights.showOnlyMyOpenedtable) === 1 || userRights.showOnlyMyOpenedtable === true));
	};

	const isTableVisible = (areaId, tableNum, tableStatus) => {
		if (tableStatus === 1) return true; // Vacant tables are always visible
		if (!isMyOpenedTableRestricted()) return true; // No restriction

		const key = `${areaId}_${tableNum}`;
		const bill = currentUpdates[key]?.[0];
		if (!bill) return true; // If no bill found, treat as visible/vacant or default to visible

		const cleanedType = userType ? userType.replace(/^"|"$/g, '').trim() : '';
		return bill.Waiter === cleanedType;
	};

	const handleAddTableClick = (areaId = 'tableview') => {
		if (!hasPermission('addNewTable')) {
			alert("You do not have permission to add new tables!");
			return;
		}
		setTableRegModalState({ from: areaId });
		setShowTableRegModal(true);
	};

	const [runningOrders, setRunningOrders] = useState([])
	const [showTableRegModal, setShowTableRegModal] = useState(false);
	const [tableRegModalState, setTableRegModalState] = useState(null);
	const [showOrdersPanel, setShowOrdersPanel] = useState(false);

	// Merge Tables Quick Action States
	const [showMergeModal, setShowMergeModal] = useState(false);
	const [selectedAreaForMerge, setSelectedAreaForMerge] = useState("");
	const [vacantTablesForMerge, setVacantTablesForMerge] = useState([]);
	const [selectedTableIdsForMerge, setSelectedTableIdsForMerge] = useState([]);
	const [mergeTableName, setMergeTableName] = useState("");
	const [mergeTableCapacity, setMergeTableCapacity] = useState("");

	const handleAreaChangeForMerge = async (areaId) => {
		setSelectedAreaForMerge(areaId);
		setSelectedTableIdsForMerge([]);
		setMergeTableName("");
		setMergeTableCapacity("");
		if (!areaId) {
			setVacantTablesForMerge([]);
			return;
		}
		try {
			const response = await axios.get(`${apiBaseUrl}/getTableToMerge/${areaId}/0/${logginedDB}`);
			if (response.status === 200) {
				setVacantTablesForMerge(response.data);
			}
		} catch (error) {
			console.error("Error fetching tables to merge:", error);
		}
	};

	const handleCheckboxChangeForMerge = (tableId, capacity, checked) => {
		let updatedSelected;
		if (checked) {
			updatedSelected = [...selectedTableIdsForMerge, tableId];
		} else {
			updatedSelected = selectedTableIdsForMerge.filter(id => id !== tableId);
		}
		setSelectedTableIdsForMerge(updatedSelected);

		// Calculate total capacity
		const totalCap = vacantTablesForMerge
			.filter(t => updatedSelected.includes(t.Table_id))
			.reduce((sum, t) => sum + (t.Table_Capacity || 0), 0);
		setMergeTableCapacity(totalCap || "");
	};

	const handleSaveMergeTables = async () => {
		if (!hasPermission('moveTable')) {
			alert("You do not have permission to merge tables!");
			return;
		}
		if (!selectedAreaForMerge) {
			return alert("Please select an area!");
		}
		if (selectedTableIdsForMerge.length < 2) {
			return alert("Please select at least 2 tables to merge!");
		}
		if (!mergeTableName || mergeTableName.trim() === "") {
			return alert("Please enter a merged table name!");
		}
		if (!mergeTableCapacity) {
			return alert("Please enter table capacity!");
		}

		try {
			const checkRes = await axios.get(`${apiBaseUrl}/checkAvailableTableName/${mergeTableName}/${logginedDB}`);
			if (checkRes.status === 200 && checkRes.data.isAvailable !== 0) {
				return alert("Duplicate name or name not available!");
			}

			const response = await axios.post(
				`${apiBaseUrl}/TableRegForMerge/${selectedAreaForMerge}/${mergeTableCapacity}/${mergeTableName}/${logginedDB}`,
				selectedTableIdsForMerge
			);

			if (response.status === 200) {
				setShowMergeModal(false);
				setSelectedAreaForMerge("");
				setVacantTablesForMerge([]);
				setSelectedTableIdsForMerge([]);
				setMergeTableName("");
				setMergeTableCapacity("");
				handleGetTablesArea();
			}
		} catch (error) {
			console.error("Error saving merged tables:", error);
			alert("Failed to merge tables");
		}
	};


	// // //(MobileViewTables.GroundFloor);
	const navigate = useNavigate(null)
	const toKOT = (id, table, area_id, area, tableNo, AreaCode, persons, tableName) => {
		setPreviewPreviousOrders(false)
		setAlreadySelectedVariants([])
		setPreviousOrdersFunc([])
		navigate('/KOT', {
			state: {
				for: id,
				table: table,
				area_id: area_id,
				area: area,
				tableNo: tableNo,
				areaCode: AreaCode,
				persons: persons,
				tableName: tableName
			}
		})
	}

	const openRunningOrder = (item) => {
		const orderType = (item?.Type || activeTab || '').toString().toLowerCase().replace(/\s+/g, '');
		const isDirectOrder = ['delivery', 'pickup', 'parcel'].includes(orderType);
		const tableNo = item?.Table_onlineName || item?.Temp_table_onlineName || item?.tableno || item?.tableNo || orderType;
		const areaId = item?.Area_id || item?.area_id || item?.floor || 0;

		setPreviewPreviousOrders(false);
		setAlreadySelectedVariants([]);
		setPreviousOrdersFunc([]);
		navigate('/KOT', {
			state: {
				for: isDirectOrder ? orderType : (item?.Table_id || item?.Temp_table_id || tableNo),
				table: item?.Temp_table_onlineName ? 'tableTemp' : (isDirectOrder ? orderType : 'table'),
				area_id: areaId,
				area: item?.AreaName || item?.area || '',
				tableNo,
				areaCode: item?.AreaCode || '',
				persons: item?.persons || item?.Table_Capacity || '',
				tableName: tableNo,
				billNo: item?.BillNo || item?.billNo || null
			}
		});
	}

	const [allTables, setAllTables] = useState(true)
	const [partyHall, setPartyHall] = useState(false)
	const [aC, setAC] = useState(false)
	const [nonAC, setNonAC] = useState(false)

	const toAllTables = () => {
		setAllTables(true)
		setPartyHall(false)
		setAC(false)
		setNonAC(false)
	}
	const toPartyHall = () => {
		setAllTables(false)
		setPartyHall(true)
		setAC(false)
		setNonAC(false)
	}
	const toAC = () => {
		setAllTables(false)
		setPartyHall(false)
		setAC(true)
		setNonAC(false)
	}
	const toNonAC = () => {
		setAllTables(false)
		setPartyHall(false)
		setAC(false)
		setNonAC(true)
	}

	const toItemsSelect = () => {
		navigate('/KOT')
	}

	const [dineInState, setDineInState] = useState(true)
	const [deliveryState, setDeliveryState] = useState(false)
	const [pickUpState, setPickUpState] = useState(false)
	const [parcelState, setParcelState] = useState(false)
	const handleDineIn = () => {
		setDineInState(true)
		setDeliveryState(false)
		setPickUpState(false)
		setParcelState(false)
	}
	const handleDelivery = () => {
		setDeliveryState(true)
		setDineInState(false)
		setPickUpState(false)
		setParcelState(false)
	}
	const handlePickUp = () => {
		setPickUpState(true)
		setDeliveryState(false)
		setDineInState(false)
		setParcelState(false)
	}
	const handleParcel = () => {
		setParcelState(true)
		setPickUpState(false)
		setDeliveryState(false)
		setDineInState(false)
	}

	const [sideNav, setSideNav] = useState(false)
	const handleSideNav = (state) => {
		setSideNav(state)
	}
	const [falseState, setFalseState] = useState(null)

	const [areaWithTables, setAreaWithTables] = useState([])



	// // console.log('areaWithTables',areaWithTables);


	const [currentUpdates, setCurrentUpdates] = useState({});

	//(currentUpdates);


	const handleGetTablesArea = async () => {
		//("hi");
		try {

			const response = await axios.get(`${apiBaseUrl}/getAreaWithTables/${logginedDB}`);

			if (response.status === 200) {
				const data = response.data

				setAreaWithTables(data);

				// Extract and merge CurrentUpdates from all areas
				let updates = {};

				data.forEach(area => {
					Object.assign(updates, area.CurrentUpdates);
				});

				setCurrentUpdates(updates);

			}
		} catch (error) {

			console.error("Error fetching areas with tables:", error);
		}

	};

	// useEffect(() => {

	//     if (logginedDB) {
	//         handleGetTablesArea();
	//     }
	//     // Connect to the WebSocket server
	//     const socket = io(apiBaseUrl);
	//     socket.on('updateTable', () => {
	//         //('Data updated, fetching new data...');
	//         handleGetTablesArea();
	//     });

	//     socket.on('tableReg', () => {
	//         //('Data updated, fetching new data...');
	//         handleGetTablesArea();
	//     });

	//     return () => {
	//         socket.disconnect();
	//     };
	// },[])


	const socketRef = useRef(null);
	const handlersRef = useRef({});

	useEffect(() => {
		if (!logginedDB) return;

		// Initial fetch on mount or database change
		if (handlersRef.current.handleGetTablesArea) handlersRef.current.handleGetTablesArea();
		if (handlersRef.current.handleGetCurrentUpdate) handlersRef.current.handleGetCurrentUpdate();

		// connect socket
		socketRef.current = io(apiBaseUrl, {
			transports: ["websocket"], // faster than polling
		});

		const onTableOrOrderUpdate = () => {
			if (handlersRef.current.handleGetTablesArea) {
				handlersRef.current.handleGetTablesArea();
			}
			if (handlersRef.current.handleGetCurrentUpdate) {
				handlersRef.current.handleGetCurrentUpdate();
			}
		};

		socketRef.current.on("updateTable", onTableOrOrderUpdate);
		socketRef.current.on("tableReg", onTableOrOrderUpdate);
		socketRef.current.on("updateKot", onTableOrOrderUpdate);
		socketRef.current.on("orderCancelled", onTableOrOrderUpdate);
		socketRef.current.on("getTableViewOrders", onTableOrOrderUpdate);
		socketRef.current.on("updateLoadOrders", onTableOrOrderUpdate);

		// cleanup on unmount
		return () => {
			if (socketRef.current) {
				socketRef.current.off("updateTable", onTableOrOrderUpdate);
				socketRef.current.off("tableReg", onTableOrOrderUpdate);
				socketRef.current.off("updateKot", onTableOrOrderUpdate);
				socketRef.current.off("orderCancelled", onTableOrOrderUpdate);
				socketRef.current.off("getTableViewOrders", onTableOrOrderUpdate);
				socketRef.current.off("updateLoadOrders", onTableOrOrderUpdate);
				socketRef.current.disconnect();
			}
		};
	}, [apiBaseUrl, logginedDB]);

	// useEffect(() => {
	//     if (!logginedDB) return;

	//     // Connect socket
	//     socketRef.current = io(apiBaseUrl, {
	//         transports: ["websocket"],
	//     });

	//     // Fixed: Remove parentheses to pass function reference, not call immediately
	//     socketRef.current
	//         .off("updateTable")
	//         .on("updateTable", handleGetTablesArea); // No parentheses

	//     socketRef.current
	//         .off("tableReg")
	//         .on("tableReg", handleGetTablesArea); // No parentheses

	//     socketRef.current
	//         .off("getTableViewOrders")
	//         .on("getTableViewOrders", handleGetCurrentUpdate); // No parentheses

	//     return () => {
	//         socketRef.current.disconnect();
	//     };
	// }, [apiBaseUrl, logginedDB]);

	const handleRemoveTempTable = async (area_id, table_id) => {
		if (!hasPermission('addNewTable')) {
			alert("You do not have permission to remove tables!");
			return;
		}
		const isConfirmed = window.confirm("Delete this temporary table?");

		if (isConfirmed) {
			try {
				const response = await axios.delete(`${apiBaseUrl}/deleteTempTable/${area_id}/${table_id}/${logginedDB}`)
				if (response.status == 200) {
					if (response.data.success) {
						handleGetTablesArea()
					} else {
						alert("Can't delete ,table ahead!")
					}
				}
			} catch (error) {
				//(error);

			}
		}
	}

	// const calculateNetTotal = (areaId, tableNum) => {
	//     const tableKey = `${areaId}_${tableNum}`;
	//     if (currentUpdates[tableKey]) {
	//         return currentUpdates[tableKey].reduce((sum, order) => sum + order.TotalAmount, 0);
	//     }
	//     return 0;
	// };

	const calculateNetTotal = (areaId, tableNum) => {
		if (!tableNum) return 0; // Avoid processing null or undefined values

		const tableKey = `${areaId}_${tableNum}`;
		if (currentUpdates[tableKey]) {
			return currentUpdates[tableKey].reduce((sum, order) => sum + order.TotalAmount, 0);
		}
		return 0;
	};



	// const handleGetCurrentUpdate = async () => {
	//     try {
	//         const response = await axios.get(`${apiBaseUrl}/getTableViewOrders/${logginedDB}`)
	//         if (response.status == 200) {
	//             // //(response.data.information);
	//             // console.log("getTableViewOrders", response);

	//             setRunningOrders(response.data)
	//             return response.data.information
	//         }
	//     } catch (error) {
	//         //(error);
	//     }
	// }

	const handleGetCurrentUpdate = async () => {
		try {
			const response = await axios.get(`${apiBaseUrl}/getTableViewOrders/${logginedDB}`)
			if (response.status == 200) {
				// console.log("getTableViewOrders", response);
				if (response.data.Table_Status === 4) {
					// console.log(response.data.Table_Status, "loggg")
				} else {
					// console.log("in else if")
					setRunningOrders(response.data)
					return response.data
				}
				// Fixed: should be response.data, not response.data.information
			}
		} catch (error) {
			console.error(error);
		}
	}

	handlersRef.current.handleGetTablesArea = handleGetTablesArea;
	handlersRef.current.handleGetCurrentUpdate = handleGetCurrentUpdate;

	// handleGetCurrentUpdate()
	// // console.log("RunningOrders", runningOrders);



	const [timers, setTimers] = useState({});

	// // console.log('timers',timers);


	useEffect(() => {
		const interval = setInterval(() => {
			setTimers((prevTimers) => {
				const updatedTimers = { ...prevTimers };
				Object.keys(updatedTimers).forEach((key) => {
					updatedTimers[key] = updatedTimers[key] + 1000; // Increment by 1 second
				});
				return updatedTimers;
			});
		}, 1000);

		return () => clearInterval(interval); // Cleanup on unmount
	}, []);

	const initializeTimer = (key, date, time) => {
		if (!timers[key]) {
			const startTime = new Date(`${date} ${time}`).getTime();
			const currentTime = Date.now();
			const elapsedTime = Math.max(0, currentTime - startTime); // Ensure no negative time
			setTimers((prevTimers) => ({ ...prevTimers, [key]: elapsedTime }));
		}
	};

	useEffect(() => {
		areaWithTables.forEach(area => {
			area.Tables.forEach(table => {
				if (table.Status === 1) {
					const key = `${area.Area_id}_${table.Table_onlineName}`;

					// Extract date and time from currentUpdates
					const update = currentUpdates[key]?.[0];
					if (update) {
						const { Date: date, Time: time } = update;

						// Ensure that date and time are valid and properly formatted
						const formattedDate = new Date(date + ' ' + time);
						if (!isNaN(formattedDate.getTime())) {
							// Only initialize timer if the date and time are valid
							initializeTimer(key, date, time);
						} else {
							console.error(`Invalid date/time for key ${key}: ${date} ${time}`);
						}
					}
				}
			});
		});
	}, [areaWithTables, currentUpdates]); // Dependencies


	const formatTime = (ms) => {
		const totalSeconds = Math.floor(ms / 1000);
		const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
		const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
		const seconds = String(totalSeconds % 60).padStart(2, '0');
		if (hours <= 0 && minutes <= 1) {
			return `${hours}:${minutes}:${seconds}`;
		} else {
			return `${hours}:${minutes}`;// if you need to add secondds just add ':${seconds}'
		}
	};




	const tabs = [
		{ label: "Dine in", status: 2 },
		{ label: "Pick Up", status: 3 },
		{ label: "Delivery", status: 4 },
		{ label: "Parcel", status: 6 },
		{ label: "KOT", status: 5 }, // special case -> show all (except status 1)
	];

	const activeTabConfig = tabs.find((t) => t.label === activeTab);
	const runningOrderMatchesActiveTab = (item) => {
		if (activeTab === "KOT") return true;

		const itemType = (item?.Type || item?.type || '').toString().toLowerCase().replace(/\s+/g, '');
		const activeType = activeTab.toLowerCase().replace(/\s+/g, '');
		const status = Number(item?.Table_Status || item?.status || item?.Status);

		return itemType === activeType || status === activeTabConfig?.status;
	};

	// Combine Tables + Temp_Tables into a single flat list
	const allTable = areaWithTables.flatMap((area) => {
		const normalTables = area.Tables.map((t) => ({
			...t,
			AreaName: area.AreaName,
			parentName: null,
		}));

		const tempTables = area.Temp_Tables.map((t) => ({
			...t,
			AreaName: area.AreaName,
			parentName: null,
		}));

		return [...normalTables, ...tempTables];
	});

	// Apply filtering logic
	const filterData = allTable.filter((t) =>
		activeTabConfig.status === 5
			? t.Table_Status !== 1 // KOT: exclude status 1
			: t.Table_Status === activeTabConfig.status
	);

	return (
		<div>
			<div className='w-screen h-screen hidden sm:flex sm:flex-col overflow-hidden'>
				<SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
				<div className='w-full bg-[#f5f5f5] flex-grow flex gap-3 overflow-hidden'>
					<div className='w-max h-full z-[9999]'>
						<SideNav focus={'Tables'} state={sideNav} falseState={(state) => setFalseState(state)} />
					</div>

					<div className='flex flex-col w-full h-full pr-3 pb-3 gap-3'>

						{/* <div className="w-full h-max bg-[#fff] borderBottom  overflow-hidden shadow-sm">
							<TopRootDiv image={'Tables'} root={['Tables']} />
						</div> */}

						<div className='flex w-full h-full gap-3 pt-3 relative'>

							{/* Right Arrow Button when collapsed */}
							{!showOrdersPanel && (
								<button
									onClick={() => setShowOrdersPanel(true)}
									className="absolute -left-4 top-1/2 -translate-y-1/2 z-20 bg-white border border-gray-200 shadow-[2px_0px_5px_rgba(0,0,0,0.05)] py-4 pl-0.5 pr-1.5 rounded-r-xl hover:bg-gray-50 opacity-80 hover:opacity-100 transition-all flex items-center justify-center border-l-0"
									title="Expand"
								>
									<svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M9 5l7 7-7 7"></path></svg>
								</button>
							)}

							<div className={`flex flex-col bg-white border border-gray-200 shadow-sm z-10 relative rounded-md overflow-hidden transition-all duration-300 ease-in-out ${showOrdersPanel ? 'w-[25%] max-w-[300px] min-w-[250px] opacity-100' : 'w-0 min-w-0 border-none opacity-0 !p-0 !m-0'}`}>

								{/* Left Arrow Button when expanded */}
								<button
									onClick={() => setShowOrdersPanel(false)}
									className="absolute right-0 top-1/2 -translate-y-1/2 z-20 bg-white/90 backdrop-blur-sm hover:bg-gray-100 py-4 px-1 rounded-l-xl transition-all border border-gray-200 border-r-0 shadow-[-2px_0px_5px_rgba(0,0,0,0.05)]"
									title="Collapse Orders Panel"
								>
									<svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M15 19l-7-7 7-7"></path></svg>
								</button>

								<div className={`flex flex-col h-full min-w-[250px] transition-opacity duration-200 ${showOrdersPanel ? 'opacity-100' : 'opacity-0'}`}>
									{/* Top Tabs */}
									<div className="flex p-2 gap-1 bg-gray-50/50 border-b border-gray-100">
										{tabs.map((tab) => (
											<button
												key={tab.label}
												onClick={() => setActiveTab(tab.label)}
												className={`flex-1 py-2 text-xs sm:text-sm font-semibold rounded-md transition-all duration-200 ${activeTab === tab.label
													? "bg-white text-blue-600 shadow-sm border border-gray-200"
													: "text-gray-500 hover:text-gray-700 hover:bg-gray-100/50"
													}`}
											>
												{tab.label}
											</button>
										))}
									</div>

								<div className="flex-1 overflow-y-auto customScroll bg-gray-50/30 p-3">
									<div className="flex items-center justify-between px-2 pb-2 mb-3 border-b border-gray-200 text-xs font-bold text-gray-500 uppercase tracking-wider">
										<div className="w-1/3 text-left">Order No</div>
										<div className="w-1/3 text-center">Table No</div>
										<div className="w-1/3 text-right">Amount</div>
									</div>

									{activeTab === "KOT" || activeTab === "Delivery" || activeTab === "Parcel" ? (
										<div className="flex flex-col gap-2">
											{runningOrders.length > 0 ? (
												runningOrders
													.filter(item => {
														if (!isMyOpenedTableRestricted()) return true;
														const cleanedType = userType ? userType.replace(/^"|"$/g, '').trim() : '';
														return item.Waiter === cleanedType;
													})
													.filter(runningOrderMatchesActiveTab)
													.map((item, index) => (
													<div
														key={index}
														className="flex items-center justify-between p-3 bg-white border border-gray-100 rounded-lg shadow-sm hover:shadow-md hover:border-blue-200 transition-all cursor-pointer group"
														onClick={() => openRunningOrder(item)}
													>
														<div className="w-1/3 text-left font-semibold text-gray-800 group-hover:text-blue-600">
															#{item?.KotNo || item?.KotNo}
														</div>
														<div className="w-1/3 text-center">
															<span className="inline-flex items-center justify-center px-2.5 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full">
																{item?.Table_onlineName || item?.Temp_table_onlineName}
															</span>
														</div>
														<div className="w-1/3 text-right font-bold text-gray-700">
															₹{item?.TotalAmount || "0"}
														</div>
													</div>
												))
											) : (
												<div className="flex flex-col items-center justify-center py-10 text-gray-400">
													<svg className="w-12 h-12 mb-3 opacity-20" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"></path></svg>
													<p className="text-sm font-medium">No orders found</p>
												</div>
											)}
										</div>
									) : (
										<div className="flex flex-col items-center justify-center py-10 text-gray-400">
											<p className="text-sm font-medium">No tables found</p>
										</div>
									)}
								</div>
								</div>
							</div>

							<div className={`w-full h-full flex flex-col pb-0 ${!showOrdersPanel ? '-ml-4' : ''} pt-0 gap-3 overflow-hidden`}>
								<div className='w-full h-full flex flex-col gap-3 font-nunito overflow-hidden'>
									<div className='w-full h-max flex items-center justify-between bg-[#fff] p-3 rounded-md shadow-sm gap-4'>
										<div className='flex flex-wrap gap-4 lg:gap-6 items-center text-[0.8rem] lg:text-sm font-bold text-gray-600'>
											{/* <div className="flex items-center gap-2"><div className="w-3.5 h-3.5 rounded-[3px] border border-gray-300 bg-[#fff] shadow-sm"></div>Blank Tables</div> */}
											<div className="flex items-center gap-2"><div className="w-3.5 h-3.5 rounded-[3px] bg-[#29C65D] shadow-sm"></div>Running Table</div>
											<div className="flex items-center gap-2"><div className="w-3.5 h-3.5 rounded-[3px] bg-[#E5E918] shadow-sm"></div>Printed Table</div>
											<div className="flex items-center gap-2"><div className="w-3.5 h-3.5 rounded-[3px] bg-[#744D29] shadow-sm"></div>Running KOT</div>
											<div className="flex items-center gap-2"><div className="w-3.5 h-3.5 rounded-[3px] bg-[#FF001F] shadow-sm"></div>Reserved</div>
										</div>
										<div className='flex justify-end items-center text-[#fff] text-[.9rem] gap-2 text-nowrap'>
											<button className='flex justify-center items-center gap-2 bg-[#0008B4] px-3 py-2 rounded-[.313rem]' onClick={() => {
												navigate('/KOT', {
													state: {
														for: 'delivery'
													}
												})
												setPreviousOrdersFunc([])
											}}>
												<img src={Delivery} className='w-[1rem] invert' alt="?" />
												<span className='D'>Delivery</span>
											</button>
											<button className='flex justify-center items-center gap-2 bg-[#0008B4] px-3 py-2 rounded-[.313rem]' onClick={() => {
												navigate('/KOT', {
													state: {
														for: 'pickup'
													}
												})
												setPreviousOrdersFunc([])
											}}>
												<img src={Pickup} className='w-[1rem] invert' alt="?" />
												<span className='P'>Pickup</span>
											</button>
											<button className='flex justify-center items-center gap-2 bg-[#0008B4] px-3 py-2 rounded-[.313rem]' onClick={() => {
												navigate('/KOT', {
													state: {
														for: 'parcel'
													}
												})
												setPreviousOrdersFunc([])
											}}>
												<img src={Parcel} className='w-[1rem] invert' alt="?" />
												<span className='P'>Parcel</span>
											</button>
											<button className='flex justify-center items-center gap-2 bg-[#0008B4] px-3 py-2 rounded-[.313rem]' onClick={() => {
												handleAddTableClick('tableview');
											}}>
												<img src={AddTable} className='w-[1rem] invert' alt="?" />
												<span className='Add'>Add Table</span>
											</button>
											{/* <button className='flex justify-center items-center gap-2 bg-[#0008B4] px-3 py-2 rounded-[.313rem]' onClick={() => {
												setShowMergeModal(true);
											}}>
												<img src={merge} className='w-[1rem] invert' alt="?" />
												<span className='Merge'>Merge Table</span>
											</button> */}
										</div>
									</div>

									{
										areaWithTables.length > 0 ? (
											<div className='h-full w-full flex flex-col p-3 bg-[#fff] gap-4 overflow-y-auto customScroll'>
												{
													areaWithTables.filter(area => area.Tables.some(table => table.Status === 1)) ? (
														areaWithTables.map((area, index) => {
															if (area.Status === 1) {
																return (
																	<div key={index} className='w-full flex flex-col gap-3'>
																		<span className='Restaurant_TView_Text'>{area.AreaName}</span>
																		{
																			(area.Tables.length > 0 || area.Temp_Tables.length > 0) ? (
																				<div className="flex items-start gap-3">
																					<div className="flex flex-wrap gap-3">
																						{
																							area.Tables.length > 0 && area.Tables.map(table => ({
																								...table,
																								resolvedName: (table.Table_onlineName && table.Table_onlineName.trim() !== "") ? table.Table_onlineName : (table.Table_num ? table.Table_num.toString() : "")
																							})).filter(table => isTableVisible(area.Area_id, table.resolvedName, table.Table_Status)).map((table, index) => {
																								if (table.Status === 1 && table.Table_num) {

																									const mergedTableCount = table.mergedTables ? table.mergedTables.split(",").length : 0;

																									const key = `${area.Area_id}_${table.resolvedName}`;

																									const netTotal = calculateNetTotal(area.Area_id, table.resolvedName);
																									const update = currentUpdates[key]?.[0];
																									if (update) {
																										const { Date: date, Time: time } = update;
																										initializeTimer(key, date, time);
																									}

																									return (
																										<div
																											key={index}
																											className={`relative w-[8rem] h-[8rem] rounded-lg flex items-center justify-center cursor-pointer p-10 shadow-[4px_4px_10px_rgba(0,0,0,0.5)]
                                                                                                            ${table.Table_Status === 2 ? 'bg-[#29C65D] text-[#000]' : table.Table_Status === 3 ? 'bg-[#E5E918] text-[#000]' :
																													table.Table_Status === 4 ? 'bg-[#744D29] text-[#fff]' : table.Reserved === 5 ? 'bg-[#FF001F] text-[#fff]' : table.Table_Status === 1 && 'bg-[#C7CDC9] text-[#000]'}`}
																											onClick={() => toKOT(table.Table_id, 'table', area.Area_id, area.AreaName, table.Table_num, area.AreaCode, table.Table_Capacity, table.resolvedName)}
																										>
																											{(timers[key] !== undefined) && (
																												<span className='absolute top-3'>
																													{formatTime(timers[key])}
																												</span>
																											)}
																											{/* <span className="font-[600]">{table.Table_num.toString().padStart(2, '0')}</span> */}
																											<div className='flex flex-col gap-1 justify-center items-center'>
																												<span className="font-[600]">{table.resolvedName}</span>
																												{mergedTableCount > 0 && (
																													<div className='flex gap-1'>
																														<div className='flex justify-center items-center'>
																															<img className={`w-[1rem] ${table.Table_Status === 4 ? 'invert' : table.Reserved === 5 ? 'invert' : ''}`} src={Roundtable} alt="" />
																														</div>
																														x
																														<span className="font-[500]">{mergedTableCount}</span>
																													</div>
																												)}
																											</div>
																											{netTotal > 0 && <span className='absolute bottom-3'>₹ {netTotal}</span>}

																											{/* {table.Table_Status === 3 && (
                                                                                                    <div className='absolute bottom-0 rounded-md transform translate-x-0 translate-y-1/2 border border-[#000] bg-[#f6f6f6] p-1 shadow-[2px_2px_5px_rgba(0,0,0,0.25)]'>
                                                                                                        <img className='w-[1rem] opacity-75' src={save} alt="" />
                                                                                                    </div>
                                                                                                )} */}
																										</div>
																									);
																								}
																							})
																						}

																						{(area.Tables.length > 0 && area.Temp_Tables.length > 0) && (
																							<div className="w-1 bg-[#b7b7b7] rounded-lg shadow-[4px_4px_10px_rgba(0,0,0,0.5)]"></div>
																						)}

																						{
																							area.Temp_Tables.length > 0 && area.Temp_Tables.map(table => ({
																								...table,
																								resolvedName: (table.Temp_table_onlineName && table.Temp_table_onlineName.trim() !== "") ? table.Temp_table_onlineName : (table.Temp_table_num ? table.Temp_table_num.toString() : "")
																							})).filter(table => isTableVisible(area.Area_id, table.resolvedName, table.Table_Status)).map((table, index) => {
																								if (table.Status === 1 && table.Temp_table_num) {
																									const key = `${area.Area_id}_${table.resolvedName}`;

																									const netTotal = calculateNetTotal(area.Area_id, table.resolvedName);

																									const update = currentUpdates[key]?.[0];
																									if (update) {
																										const { Date: date, Time: time } = update;
																										initializeTimer(key, date, time);
																									}
																									return (
																										<div
																											key={index}
																											className={`relative w-[8rem] h-[8rem] rounded-lg borderDashedBlank opacity-75 flex items-center justify-center cursor-pointer p-10 shadow-[4px_4px_10px_rgba(0,0,0,0.5)]
                                                                                                            ${table.Table_Status === 2 ? 'bg-[#29C65D] text-[#000]' : table.Table_Status === 3 ? 'bg-[#E5E918] text-[#000]' :
																													table.Table_Status === 4 ? 'bg-[#744D29] text-[#fff]' : table.Reserved === 5 ? 'bg-[#FF001F] text-[#fff]' : table.Table_Status === 1 && 'bg-[#C7CDC9] text-[#000]'}`}
																											onClick={() => toKOT(table.Temp_table_id, 'tableTemp', area.Area_id, area.AreaName, table.Temp_table_num, area.AreaCode, table.Temp_table_Capacity, table.resolvedName)}
																										>
																											{(timers[key] !== undefined) && (
																												<span className='absolute top-3'>
																													{formatTime(timers[key])}
																												</span>
																											)}
																											{/* <span>{table.Temp_table_num}</span> */}
																											<span>{table.resolvedName}</span>
																											{netTotal > 0 && <span className='absolute bottom-3'>₹ {netTotal}</span>}
																											{table.Merged !== 1 && (
																												<img className={`absolute right-1 top-1 w-[1rem] cursor-pointer ${table.Table_Status === 4 ? 'invert opacity-100' : table.Reserved === 5 ? 'invert opacity-100' : 'opacity-75'}`}
																													src={Remove} alt="" onClick={(e) => {
																														e.stopPropagation();
																														handleRemoveTempTable(area.Area_id, table.Temp_table_id);
																													}} />
																											)}
																										</div>
																									);
																								}
																							})
																						}
																						<div className="w-[8rem] h-[8rem] rounded-lg bg-[#FAFAFA] borderDashed flex items-center justify-center cursor-pointer p-2 shadow-md hover:bg-[#F0F0F0]" onClick={() => {
																							handleAddTableClick(area.Area_id);
																						}}>

																							<div className='text-[.9rem] text-center flex flex-col justify-center items-center opacity-75'>
																								<span className='text-nowrap flex justify-center items-center'>Add&nbsp;[<img className='w-[.9rem]' src={Add} alt="+" />]</span>
																								<span>Temporary <br /> Table</span>
																							</div>
																						</div>
																					</div>
																				</div>
																			) : (
																				<div>No table registered or active!</div>
																			)
																		}
																	</div>
																)
															}
														})
													) : (
														<div>No table registered or active!</div>
													)
												}
											</div>
										) : (
											<div className='h-full w-full flex flex-col gap-3 overflow-y-auto customScroll'>No area regisered or active!</div>
										)
									}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* ..........................................Mobile View ................................................*/}

			<div className='w-screen h-screen flex flex-col sm:!hidden overflow-hidden'>
				<div className='w-full h-max sticky top-0'>
					<NavBarMobile title={'Tables'} />
				</div>
				<div className='relative w-full h-full overflow-hidden' onClick={() => sideNavStateFunc(true)}>
					<div className={`h-full w-max absolute left-0 bg-[#f5f5f5] transition-transform duration-5000 z-[9999] ${sideNavState ? "translate-x-0 ease-out shadow-[5px_5px_100px_rgba(0,0,0,0.4)]" : "-translate-x-full ease-in duration-5000"
						}`}>
						<SideNavMob focus={'Tables'} state={sideNav} falseState={(state) => setFalseState(state)} />
					</div>
					<div className='w-full h-full flex flex-col gap-3 p-3 font-nunito overflow-auto noScroll'>
						<div className='w-full h-max flex gap-3 text-center font-[600]'>
							<div className={`rounded-[.313rem] w-1/4 p-2 flex justify-center items-center ${dineInState ? 'bg-[#0008B4] text-[#fff]' : 'bg-[#F5F5F5]'}`} onClick={handleDineIn}>DINE IN</div>
							<div className={`rounded-[.313rem] w-1/4 p-2 flex justify-center items-center ${deliveryState ? 'bg-[#0008B4] text-[#fff]' : 'bg-[#F5F5F5]'}`} onClick={() => navigate('/KOT', {
								state: {
									for: 'delivery'
								}
							})}>DELIVERY</div>
							<div className={`rounded-[.313rem] w-1/4 p-2 flex justify-center items-center ${pickUpState ? 'bg-[#0008B4] text-[#fff]' : 'bg-[#F5F5F5]'}`} onClick={() => navigate('/KOT', {
								state: {
									for: 'pickup'
								}
							})}>PICK UP</div>
							<div className={`rounded-[.313rem] w-1/4 p-2 flex justify-center items-center ${parcelState ? 'bg-[#0008B4] text-[#fff]' : 'bg-[#F5F5F5]'}`} onClick={() => navigate('/KOT', {
								state: {
									for: 'parcel'
								}
							})}>PARCEL</div>
						</div>
						{dineInState && (
							<div className='w-full h-full flex flex-col gap-3 relative'>
								<div className='w-full h-max flex gap-3 font-[600] text-nowrap noScroll overflow-x-auto sticky top-0'>
									<div className={`w-max flex justify-center items-center ${allTables ? 'borderBottomMobActive text-[#000]' : 'borderBottomMob text-[#999999]'}`} onClick={toAllTables}>All Tables</div>
									<div className={`w-max flex justify-center items-center ${partyHall ? 'borderBottomMobActive' : 'borderBottomMob text-[#999999]'}`} onClick={toPartyHall}>Party Hall</div>
									<div className={`w-max flex justify-center items-center ${aC ? 'borderBottomMobActive' : 'borderBottomMob text-[#999999]'}`} onClick={toAC}>AC</div>
									<div className={`w-max flex justify-center items-center ${nonAC ? 'borderBottomMobActive' : 'borderBottomMob text-[#999999]'}`} onClick={toNonAC}>Non AC</div>
								</div>
								{allTables && (
									<div className='w-full h-full flex flex-col gap-3 overflow-auto noScroll'>
										{
											areaWithTables.filter(area => area.Tables.some(table => table.Status === 1)).map((area, index) => {
												if (area.Status === 1) {
													return (
														<div key={index} className='w-full flex flex-col gap-3'>
															<span className='w-full text-[1.15rem] font-[600] flex'>{area.AreaName}</span>
															{
																area.Tables.length > 0 ? (
																	<div className="grid sm_mob:grid-cols-2 md_mob:grid-cols-3 lg_mob:grid-cols-4 gap-3 p-1 w-full">
																		{
																			area.Tables.map(table => ({
																				...table,
																				resolvedName: (table.Table_onlineName && table.Table_onlineName.trim() !== "") ? table.Table_onlineName : (table.Table_num ? table.Table_num.toString() : "")
																			})).filter(table => isTableVisible(area.Area_id, table.resolvedName, table.Table_Status)).map((table, index) => {
																				if (table.Status === 1) {

																					const mergedTableCount = table.mergedTables ? table.mergedTables.split(",").length : 0;

																					const key = `${area.Area_id}_${table.resolvedName}`;

																					const netTotal = calculateNetTotal(area.Area_id, table.resolvedName);
																					// Extract date and time from currentUpdates
																					const update = currentUpdates[key]?.[0];
																					if (update) {
																						const { Date: date, Time: time } = update;
																						initializeTimer(key, date, time);
																					}
																					return (
																						<div
																							key={index}
																							className={`relative h-[7rem] rounded-lg flex items-center justify-center cursor-pointer p-10 shadow-[1px_2px_5px_rgba(0,0,0,0.5)]`}
																							onClick={() => toKOT(table.Table_id, 'table', area.Area_id, area.AreaName, table.Table_num.toString().padStart(2, '0'), area.AreaCode, table.Table_Capacity, table.resolvedName)}
																						>
																							{(timers[key] !== undefined) && (
																								<span className='absolute top-3'>
																									{formatTime(timers[key])}
																								</span>
																							)}
																							{/* <span className='text-[1rem] font-[600]'>{table.Table_num.toString().padStart(2, '0')}</span> */}
																							<div className='flex flex-col gap-1 justify-center items-center'>
																								<span className="font-[600]">{table.resolvedName}</span>
																								{mergedTableCount > 0 && (
																									<div className='flex gap-1'>
																										<div className='flex justify-center items-center'>
																											<img className={`w-[1rem] ${table.Table_Status === 4 ? 'invert' : table.Reserved === 5 ? 'invert' : ''}`} src={Roundtable} alt="" />
																										</div>
																										x
																										<span className="font-[500]">{mergedTableCount}</span>
																									</div>
																								)}
																							</div>
																							{netTotal > 0 && <span className='absolute bottom-3'>₹ {netTotal}</span>}
																							<div className={`absolute right-0 top-0 w-[1.5rem] h-[1.5rem] rounded-tr-[.313rem] rounded-bl-[.313rem] ${table.Table_Status === 2 ? 'bg-[#29C65D]' : table.Table_Status === 3 ? 'bg-[#E5E918]' :
																								table.Table_Status === 4 ? 'bg-[#744D29]' : table.Reserved === 5 ? 'bg-[#FF001F] ' : table.Table_Status === 1 ? 'bg-[#C7CDC9]' : 'bg-[#fff]'}`}></div>
																						</div>
																					)
																				}
																			})
																		}
																		{
																			area.Temp_Tables.map(table => ({
																				...table,
																				resolvedName: (table.Temp_table_onlineName && table.Temp_table_onlineName.trim() !== "") ? table.Temp_table_onlineName : (table.Temp_table_num ? table.Temp_table_num.toString() : "")
																			})).filter(table => isTableVisible(area.Area_id, table.resolvedName, table.Table_Status)).map((table, index) => {
																				if (table.Status === 1) {

																					const key = `${area.Area_id}_${table.resolvedName}`;

																					const netTotal = calculateNetTotal(area.Area_id, table.resolvedName);

																					// Extract date and time from currentUpdates
																					// const update = currentUpdates[key]?.[0];
																					// if (update) {
																					//     const { Date: date, Time: time } = update;
																					//     initializeTimer(key, date, time);
																					// }
																					return (
																						<div
																							key={index}
																							className={`relative h-[7rem] rounded-lg borderDashedBlank opacity-75 flex items-center justify-center cursor-pointer p-10 shadow-[1px_2px_5px_rgba(0,0,0,0.5)]`}
																							onClick={() => toKOT(table.Temp_table_id, 'tableTemp', area.Area_id, area.AreaName, table.Temp_table_num, area.AreaCode, table.Temp_table_Capacity, table.resolvedName)}
																						>
																							{(timers[key] !== undefined) && (
																								<span className='absolute top-3'>
																									{formatTime(timers[key])}
																								</span>
																							)}
																							{/* <span>{table.Temp_table_num}</span> */}
																							<span>{table.resolvedName}</span>
																							{netTotal > 0 && <span className='absolute bottom-3'>₹ {netTotal}</span>}
																							<div className={`absolute right-0 top-0 w-[1.5rem] h-[1.5rem] flex justify-center items-center rounded-tr-[.313rem] rounded-bl-[.313rem] ${table.Table_Status === 2 ? 'bg-[#29C65D] ' : table.Table_Status === 3 ? 'bg-[#E5E918] ' :
																								table.Table_Status === 4 ? 'bg-[#744D29]' : table.Reserved === 5 ? 'bg-[#FF001F]' : table.Table_Status === 1 ? 'bg-[#C7CDC9]' : 'bg-[#fff]'}`}>
																								{table.Merged !== 1 && (
																									<img className={`w-[1rem] ${table.Table_Status === 4 ? 'invert opacity-100' : table.Reserved === 5 ? 'invert opacity-100' : 'opacity-75'}`}
																										src={Remove} alt="" onClick={(e) => {
																											e.stopPropagation()
																											handleRemoveTempTable(area.Area_id, table.Temp_table_id)
																										}} />
																								)}
																							</div>
																						</div>
																					)
																				}
																			})
																		}
																		<div className="h-[7rem] rounded-lg bg-[#FAFAFA] borderDashed flex items-center justify-center cursor-pointer p-2 shadow-md hover:bg-[#F0F0F0]" onClick={() => {
																			if (!hasPermission('addNewTable')) {
																				alert("You do not have permission to add new tables!");
																				return;
																			}
																			navigate('/tablereg', {
																				state: {
																					from: area.Area_id,
																				}
																			});
																		}}>

																			<div className='text-[.9rem] text-center flex flex-col justify-center items-center opacity-75'>
																				<span className='text-nowrap flex justify-center items-center'>Add&nbsp;[<img className='w-[.9rem]' src={Add} alt="+" />]</span>
																				<span>Temporary <br /> Table</span>
																			</div>
																		</div>
																	</div>
																) : (
																	<div>No table registered or active!</div>
																)
															}
														</div>
													)
												}
											})
										}
									</div>
								)}
							</div>
						)}
					</div>
				</div>
			</div>
			{showTableRegModal && (
				<TableReg
					asModal={true}
					propState={tableRegModalState}
					onClose={(success) => {
						setShowTableRegModal(false);
						if (success) {
							handleGetTablesArea();
						}
					}}
				/>
			)}
			{showMergeModal && (
				<div className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/5 backdrop-blur-[1px]" onClick={() => setShowMergeModal(false)}>
					<div className="bg-white rounded-2xl shadow-[0_20px_50px_-12px_rgba(0,0,0,0.25)] border border-white/20 w-full max-w-2xl flex flex-col transform transition-all scale-100" onClick={(e) => e.stopPropagation()}>
						{/* Modal Header */}
						<div className="bg-white rounded-t-2xl px-8 py-3 flex justify-between items-center border-b border-gray-100">
							<h2 className="text-xl font-bold text-gray-800 tracking-tight">Merge Tables</h2>
							<button onClick={() => setShowMergeModal(false)} className="text-gray-400 hover:text-gray-600 transition-colors rounded-full p-1.5 hover:bg-gray-100">
								<svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
							</button>
						</div>
						{/* Modal Body */}
						<div className="p-8 flex flex-col gap-6 font-nunito bg-gray-50/30 overflow-y-auto max-h-[70vh]">
							<div className="mb-2">
								<div className="w-1/2">
									<span className="block font-semibold text-gray-700 text-sm mb-1.5">Select Area</span>
									<select
										className="w-full p-2.5 bg-white border border-gray-200 rounded-xl focus:ring-4 focus:ring-gray-900/10 focus:border-gray-900 outline-none transition-all text-sm font-semibold"
										value={selectedAreaForMerge}
										onChange={(e) => handleAreaChangeForMerge(e.target.value)}
									>
										<option value="">Select Area</option>
										{areaWithTables.map((area) => (
											<option key={area.Area_id} value={area.Area_id}>
												{area.AreaName}
											</option>
										))}
									</select>
								</div>
							</div>

							{selectedAreaForMerge && (
								<div className="flex flex-col gap-4">
									{vacantTablesForMerge.length > 0 ? (
										<div className="flex flex-col gap-2">
											<span className="block font-semibold text-gray-700 text-sm">Select Vacant Tables to Merge</span>
											<div className="grid grid-cols-3 gap-3 max-h-[200px] overflow-y-auto p-2 bg-white border border-gray-100 rounded-xl">
												{vacantTablesForMerge.map((table) => {
													const isChecked = selectedTableIdsForMerge.includes(table.Table_id);
													return (
														<label key={table.Table_id} className={`flex items-center gap-2 p-2.5 rounded-lg border cursor-pointer transition-all ${isChecked ? 'bg-blue-50/50 border-blue-200' : 'bg-gray-50/30 border-gray-100 hover:bg-gray-50'}`}>
															<input
																type="checkbox"
																className="w-4 h-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
																checked={isChecked}
																onChange={(e) => handleCheckboxChangeForMerge(table.Table_id, table.Table_Capacity, e.target.checked)}
															/>
															<span className="text-sm font-medium text-gray-700">{table.Table_onlineName || table.Table_num}</span>
														</label>
													);
												})}
											</div>
										</div>
									) : (
										<div className="text-sm text-gray-500 italic">No vacant, unmerged tables available in this area.</div>
									)}

									{selectedTableIdsForMerge.length >= 2 && (
										<div className="flex flex-col gap-4 mt-2">
											<div className="flex gap-4">
												<div className="w-1/2 flex flex-col gap-1.5">
													<span className="font-semibold text-gray-700 text-sm">Merged Table Name</span>
													<input
														className="p-3 bg-white border border-gray-200 rounded-xl focus:ring-4 focus:ring-gray-900/10 focus:border-gray-900 shadow-sm outline-none transition-all"
														type="text"
														placeholder="e.g. M1"
														value={mergeTableName}
														onChange={(e) => setMergeTableName(e.target.value)}
													/>
												</div>
												<div className="w-1/2 flex flex-col gap-1.5">
													<span className="font-semibold text-gray-700 text-sm">Capacity</span>
													<input
														className="p-3 bg-white border border-gray-200 rounded-xl focus:ring-4 focus:ring-gray-900/10 focus:border-gray-900 shadow-sm outline-none transition-all"
														type="number"
														value={mergeTableCapacity}
														onChange={(e) => setMergeTableCapacity(parseInt(e.target.value, 10) || 0)}
													/>
												</div>
											</div>
										</div>
									)}
								</div>
							)}
						</div>
						{/* Modal Footer */}
						<div className="px-8 py-3 bg-white rounded-b-2xl border-t border-gray-100 flex justify-end gap-3">
							<button className='px-6 py-2.5 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-xl hover:bg-gray-50 hover:border-gray-400 transition-all shadow-sm focus:ring-4 focus:ring-gray-100 outline-none' onClick={() => setShowMergeModal(false)}>Cancel</button>
							<button className='px-6 py-2.5 text-sm font-semibold text-white bg-gray-900 rounded-xl hover:bg-black transition-all shadow-[0_4px_14px_0_rgba(0,0,0,0.2)] focus:ring-4 focus:ring-gray-300 outline-none' onClick={handleSaveMergeTables}>Merge Tables</button>
						</div>
					</div>
				</div>
			)}
		</div>
	)
}

export default TableView
